// ============================================================================
// SIMPLIFIED CHINESE TRANSLATIONS - CHAPTER 5: 初代教会
// ============================================================================
// 级别 53-65 (13个级别，39个问题)

export const chapter5Translations = {
  name: "初代教会",
  description: "你们要得着能力...",
  
  spiritualWisdom: {
    principle: "圣灵赐下见证的能力和勇气",
    scripture: "圣灵降临在你们身上，你们就必得着能力，并要作我的见证 (使徒行传 1:8)",
    application: "教会在圣灵的火中诞生，因勇敢的见证而成长"
  },
  
  levels: {
    53: {
      name: "升天",
      challenge: "你们要作我的见证...直到地极...",
      easy: {
        question: "耶稣在复活后多少天升天？",
        options: ["30天", "40天", "50天", "60天"],
        hint: "预备的圣经数字",
        funFact: "☁️ 世界宣教前40天的密集教导！"
      },
      medium: {
        question: "耶稣升天前作了什么应许？",
        options: [
          "立刻回来",
          "带着能力差遣圣灵",
          "建立教会",
          "惩罚恶人"
        ],
        hint: "从上头来的能力",
        funFact: "⚡ 圣灵的应许 - 惧怕的门徒的转变！"
      },
      hard: {
        question: "升天在我们的属灵生命中象征什么？",
        options: [
          "耶稣同在的结束",
          "耶稣在天上掌权并为我们代求",
          "最后的告别",
          "象征性神话"
        ],
        hint: "关乎荣耀中活着的同在",
        funFact: "👑 耶稣坐在神的右边掌权并为我们代求！"
      }
    },
    
    54: {
      name: "五旬节",
      challenge: "他们都被圣灵充满，就说起话来...",
      easy: {
        question: "升天后多少天发生了五旬节？",
        options: ["7天", "10天", "14天", "20天"],
        hint: "大约十天",
        funFact: "🔟 10天热切祷告预备圣灵的浇灌！"
      },
      medium: {
        question: "圣灵以什么形式显现？",
        options: [
          "如同大风刮过",
          "如同舌头分开，形状像火",
          "如同鸽子",
          "如同光"
        ],
        hint: "停在每个门徒身上的火焰",
        funFact: "🔥 火焰般的舌头：圣灵赐下勇气和方言的恩赐！"
      },
      hard: {
        question: "五旬节对普世教会代表什么？",
        options: [
          "孤立的历史事件",
          "宣教教会的正式诞生",
          "好奇的神迹",
          "节期的开始"
        ],
        hint: "关乎教会的出生证明",
        funFact: "🎂 五旬节 = 教会的生日，世界宣教的开始！"
      }
    },

    55: {
      name: "彼得的第一次讲道",
      challenge: "我们当怎样行，弟兄们？你们要悔改...",
      easy: {
        question: "彼得讲道后有多少人受洗？",
        options: ["1000人", "2000人", "3000人", "5000人"],
        hint: "三千灵魂",
        funFact: "🌊 一天3000人受洗 - 非凡的属灵觉醒！"
      },
      medium: {
        question: "彼得指责众人什么罪？",
        options: [
          "无知",
          "把弥赛亚耶稣钉在十字架上",
          "缺乏信心",
          "假冒为善"
        ],
        hint: "对神儿子的至高罪行",
        funFact: "⚔️ 曾经否认耶稣的彼得，现在宣告祂的神性！"
      },
      hard: {
        question: "彼得的改变如何显明圣灵的工作？",
        options: [
          "变得更有教养",
          "从胆怯不稳到勇敢信心坚固",
          "获得权力",
          "性格改变"
        ],
        hint: "关乎圣灵的成圣",
        funFact: "🗿 '摇动的芦苇'变成'坚固的磐石' - 转变的大能！"
      }
    },

    56: {
      name: "最初的团契",
      challenge: "他们恒心遵守使徒的教训，彼此交接...",
      easy: {
        question: "最初的基督徒如何分享财物？",
        options: [
          "各人保留自己的",
          "分享一切",
          "只有富人给予",
          "通过法律义务"
        ],
        hint: "自愿分享财物",
        funFact: "🤝 弟兄之爱如此强烈，以至于自愿分享一切！"
      },
      medium: {
        question: "最初的基督徒把时间花在什么上？",
        options: [
          "只做生意",
          "教导、团契、擘饼、祷告",
          "只工作",
          "休闲"
        ],
        hint: "团契生活的四大支柱",
        funFact: "⛪ 教导、团契、圣餐、祷告 - 教会的根基！"
      },
      hard: {
        question: "为什么这个最初的团契如此吸引人？",
        options: [
          "他们很富有",
          "真诚的爱和喜乐从他们的合一中散发",
          "他们应许神迹",
          "他们批评别人"
        ],
        hint: "关乎爱的活见证",
        funFact: "✨ '看哪，他们彼此相爱！' - 比言语更有说服力的见证！"
      }
    },

    57: {
      name: "瘸子得医治",
      challenge: "金银我都没有，只把我所有的给你...",
      easy: {
        question: "这个人瘸腿多久了？",
        options: [
          "20年",
          "30年", 
          "生来就瘸腿",
          "10年"
        ],
        hint: "生来就残疾",
        funFact: "🚶 40年的残疾因耶稣的名立刻得医治！"
      },
      medium: {
        question: "彼得奉谁的名医治瘸子？",
        options: [
          "奉神的名",
          "奉拿撒勒人耶稣基督的名",
          "奉自己的名",
          "奉亚伯拉罕的名"
        ],
        hint: "超乎万名之上的名",
        funFact: "✊ 耶稣的名继续通过使徒行神迹！"
      },
      hard: {
        question: "这次医治对福音象征什么？",
        options: [
          "简单的医学奇迹",
          "耶稣带来的完全救恩：属灵和身体的",
          "使徒的能力",
          "对穷人的慈善"
        ],
        hint: "关乎人的全然救赎",
        funFact: "🩺 耶稣医治灵魂和身体 - 人的完全救恩！"
      }
    },

    58: {
      name: "逼迫开始",
      challenge: "顺从神，不顺从人，是应当的...",
      easy: {
        question: "瘸子得医治后，谁逮捕了彼得和约翰？",
        options: [
          "罗马人",
          "撒都该人和祭司",
          "百姓",
          "彼拉多"
        ],
        hint: "犹太宗教当局",
        funFact: "⛓️ 第一次宗教逼迫 - 福音搅动既得利益！"
      },
      medium: {
        question: "当局禁止使徒做什么？",
        options: [
          "离开耶路撒冷",
          "不可再奉耶稣的名教训人",
          "不可再行神迹",
          "不可再祷告"
        ],
        hint: "禁止传道",
        funFact: "🚫 试图使真理沉默 - 不可能阻止福音！"
      },
      hard: {
        question: "使徒如何回应这个禁令？",
        options: [
          "害怕并顺从",
          "宣告顺从神不顺从人是应当的",
          "谈判",
          "逃跑"
        ],
        hint: "关乎高于人类法律的忠诚",
        funFact: "⚖️ 为顺从神而公民不服从 - 信念的勇气！"
      }
    },

    59: {
      name: "亚拿尼亚和撒非喇",
      challenge: "你不是欺哄人，是欺哄神了...",
      easy: {
        question: "亚拿尼亚和撒非喇说了什么谎言？",
        options: [
          "他们什么都没卖",
          "私自留下一部分却说献上全部",
          "他们很穷",
          "他们没结婚"
        ],
        hint: "关于奉献金额的谎言",
        funFact: "💰 留下一部分是可以的，但对奉献说谎不行！"
      },
      medium: {
        question: "说谎后他们发生了什么？",
        options: [
          "被赦免",
          "立刻死了",
          "被驱逐",
          "悔改了"
        ],
        hint: "立即的严厉惩罚",
        funFact: "⚱️ 严厉的审判，为保守初生教会的纯洁！"
      },
      hard: {
        question: "为什么在教会初期有如此严厉的惩罚？",
        options: [
          "神很残忍",
          "为建立对团契要求的圣洁",
          "为吓唬人",
          "偶然"
        ],
        hint: "关乎保持属灵诚信",
        funFact: "🔥 起初设立高标准，以建立圣洁的文化！"
      }
    },

    60: {
      name: "七个执事",
      challenge: "当从你们中间选出七个有好名声的人...",
      easy: {
        question: "选了多少个执事？",
        options: ["5个", "6个", "7个", "12个"],
        hint: "完全的数字",
        funFact: "7️⃣ 七个执事服事 - 教会的神圣组织！"
      },
      medium: {
        question: "他们的主要职责是什么？",
        options: [
          "传福音",
          "管理饭食，帮助寡妇",
          "给新信徒施洗",
          "管理财务"
        ],
        hint: "社会和物质服事",
        funFact: "🍽️ 管理饭食 = 第一个基督教慈善组织！"
      },
      hard: {
        question: "这个组织揭示了关于服事的基督教观念是什么？",
        options: [
          "物质工作低人一等",
          "属灵服事和物质服事同样神圣",
          "必须分开圣与俗",
          "只有祭司真正服事"
        ],
        hint: "关乎一切爱的服事的神圣性",
        funFact: "✨ 管理饭食与讲道同样尊贵 - 一切服事都是神圣的！"
      }
    },

    61: {
      name: "司提反，第一位殉道者",
      challenge: "主啊，不要将这罪归于他们！说了这话，就睡了...",
      easy: {
        question: "司提反在教会中的角色是什么？",
        options: ["使徒", "执事", "祭司", "先知"],
        hint: "被选服事的七人之一",
        funFact: "✨ 司提反：执事成为大有能力的传福音者和第一位殉道者！"
      },
      medium: {
        question: "司提反指责犹太领袖什么？",
        options: [
          "腐败",
          "时常抗拒圣灵",
          "假冒为善",
          "贪婪"
        ],
        hint: "对神的历史性抵抗",
        funFact: "📜 司提反总结历史：对神不断的悖逆！"
      },
      hard: {
        question: "司提反如何死去，他的态度揭示了什么？",
        options: [
          "对行刑者愤怒",
          "像十字架上的耶稣一样饶恕",
          "绝望中",
          "咒诅仇敌"
        ],
        hint: "关乎对基督的完美效法",
        funFact: "💝 饶恕行刑者：司提反完美再现耶稣的态度！"
      }
    },

    62: {
      name: "腓利和埃塞俄比亚太监",
      challenge: "没有人指教我，怎能明白呢？",
      easy: {
        question: "太监在车上读什么？",
        options: [
          "诗篇",
          "先知以赛亚书",
          "创世记",
          "箴言"
        ],
        hint: "预言弥赛亚受难的先知",
        funFact: "📖 以赛亚书53章 - 真诚寻求者所读的关于耶稣的完美预言！"
      },
      medium: {
        question: "腓利如何解释以赛亚的经文？",
        options: [
          "讲述古代历史",
          "从这经文起，向他传讲耶稣",
          "进行神学讲座",
          "批评解释"
        ],
        hint: "圣经自然引向基督",
        funFact: "✝️ 所有圣经都汇聚于耶稣 - 理解的钥匙！"
      },
      hard: {
        question: "埃塞俄比亚太监的归信象征什么？",
        options: [
          "孤立的归信",
          "福音对所有种族和身份的普世性",
          "某个民族的优越性",
          "特殊案例"
        ],
        hint: "关乎向万国开放",
        funFact: "🌍 埃塞俄比亚人、太监、大臣：福音打破一切障碍！"
      }
    },

    63: {
      name: "大数的扫罗归主",
      challenge: "扫罗，扫罗，你为什么逼迫我？",
      easy: {
        question: "扫罗归主前在做什么？",
        options: [
          "传福音",
          "逼迫基督徒",
          "中立",
          "只学习"
        ],
        hint: "门徒的激烈仇敌",
        funFact: "⚔️ 扫罗仍然向主的门徒口吐威吓凶杀的话！"
      },
      medium: {
        question: "耶稣在哪条路上向扫罗显现？",
        options: [
          "去耶路撒冷的路",
          "去大马士革的路",
          "去加沙的路",
          "去安提阿的路"
        ],
        hint: "叙利亚的城市",
        funFact: "🛤️ 大马士革路 = 历史上最著名的转变地点！"
      },
      hard: {
        question: "这次归信如何显明神的恩典？",
        options: [
          "神只让好人归信",
          "恩典能把最坏的仇敌变成最伟大的使徒",
          "归信是应得的",
          "扫罗已经接近神"
        ],
        hint: "关乎恩典改变的大能",
        funFact: "⚡ 从最大的逼迫者到最大的宣教士 - 恩典的神迹！"
      }
    },

    64: {
      name: "彼得和哥尼流",
      challenge: "我真看出神是不偏待人的...",
      easy: {
        question: "哥尼流的职业是什么？",
        options: [
          "商人",
          "罗马百夫长",
          "祭司",
          "文士"
        ],
        hint: "罗马军队的军官",
        funFact: "🎖️ 第一个正式归信的外邦人 - 向非犹太人开放！"
      },
      medium: {
        question: "彼得在见哥尼流之前看到什么异象？",
        options: [
          "天使说话",
          "一块布，上面有洁净和不洁净的动物",
          "耶稣显现",
          "圣殿被毁"
        ],
        hint: "关于洁净与不洁净的异象",
        funFact: "🕊️ 装着动物的布：神废除食物和种族的区别！"
      },
      hard: {
        question: "这次归信确立了什么革命性原则？",
        options: [
          "罗马人优越",
          "神不偏待人 - 普世救恩",
          "必须放弃传统",
          "割礼无用"
        ],
        hint: "关乎救恩的普世性",
        funFact: "🌍 属灵革命：福音是给所有民族的，无一例外！"
      }
    },

    65: {
      name: "安提阿教会",
      challenge: "门徒称为基督徒是从安提阿起首...",
      easy: {
        question: "门徒在安提阿第一次被称为什么？",
        options: ["门徒", "基督徒", "信徒", "圣徒"],
        hint: "我们至今使用的名字",
        funFact: "✝️ '基督徒' = '小基督' - 外邦人给的荣誉之名！"
      },
      medium: {
        question: "谁和巴拿巴一起来安提阿教导？",
        options: [
          "彼得",
          "保罗（扫罗）",
          "雅各",
          "约翰"
        ],
        hint: "从前的逼迫者成为使徒",
        funFact: "👥 巴拿巴去大数找保罗 - 保罗事工的开始！"
      },
      hard: {
        question: "为什么安提阿在基督教历史中变得如此重要？",
        options: [
          "很富有",
          "向外邦人宣教的第一个中心",
          "地理位置好",
          "有好领袖"
        ],
        hint: "关乎宣教扩展",
        funFact: "🚢 安提阿：保罗所有欧洲宣教旅程的出发港！"
      }
    }
  }
};

export default chapter5Translations;
